import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LocationOverviewIndexRoute extends Route {
  @service router;

  redirect() {
    this.router.transitionTo('location-overview.locations');
  }
}
